<script>

import WebsitesForm from './WebsitesForm';

export default {
  props: ['replacefilters', 'changefilters'],
  components: { WebsitesForm },
  data() {
    return {
      dsbl_btn: false,
      show_filters: false,
      changes: false,

      search: '',
      dateRange: { startDate: null, endDate: null },

      status_list: [
        {value: '1', name: 'Active'},
        {value: '0', name: 'Not Active'},
        {value: '', name: 'Active & Not Active'},
      ],

      feed_types: [
        {id: 'listings', name: 'Listings', active: false},
        {id: 'mls_listings', name: 'MLS Listings', active: false},
        {id: 'api_listings', name: 'API Listings', active: false},
      ],

      default_new_website: {
        status: 1,
        title: '',
        website_id: '',
        website_domain: '',
        feed_type: 'listings',
        mail_recipients: [],
        site_logo: '',
        site_phone: '',
        site_email: '',
        site_facebook: '',
        site_instagram: '',
        site_twitter: '',
        site_youtube: '',
        site_address: '',
        site_city: '',
        site_state: '',
        site_zip_code: '',
        site_latitude: '',
        site_longitude: '',
        site_timezone: 'America/Phoenix',
        site_navbar: {type: 'site-navbar', init: 'Yes', left_nav: [], account_menu: []},
        site_footer: {type: 'site-footer', init: 'Yes', menu_1: [], menu_2: [], menu_3: [], menu_base: []},
        blog_categories: [],
        faq_categories: [],
        vendor_locations: [],
        vendor_categories: [],
      },
      new_website: {},

      loading: true,
      results: [],
      pagination: {},
      filters: {
        paginate: 50,
        page: 1,
        total: 0,
        selects: [
          'id',
          'status',
          'title',
          'website_id',
          'website_domain',
          'feed_type',
          'mail_recipients',
          'site_logo',
          'site_phone',
          'site_email',
          'site_facebook',
          'site_instagram',
          'site_twitter',
          'site_youtube',
          'site_address',
          'site_city',
          'site_state',
          'site_zip_code',
          'site_latitude',
          'site_longitude',
          'site_timezone',
          'created_at',
          'updated_at',
          'deleted_at',
        ],
        wheres: {
          status: '',
        },
        whereins: {
          feed_type: [],
        },
        betweens: {
          created_at: {
            start: '',
            end: ''
          }
        },
        searchs: {
          search1: {
            value: ''
          }
        },
        orderbys: {

        },
      },
    }
  },
  watch: {
    'dateRange': { handler: function(n, o) {
      if(n.startDate && n.endDate && this.moment(n.startDate).isValid() && this.moment(n.endDate).isValid()) {
        this.filters.betweens.created_at.start = this.moment(n.startDate).startOf('day').format();
        this.filters.betweens.created_at.end = this.moment(n.endDate).endOf('day').format();
      } else {
        this.filters.betweens.created_at.start = '';
        this.filters.betweens.created_at.end = '';
      }
    }, deep: true },
    '$route.params.id': function (id) { if(!id) { console.log("Route param changed. Updating"); this.fetchData(); } },

    'loading': { handler: function(n, o) { this.$emit('loadchange', n) }},

    'filters.paginate': { handler: function(n, o) { this.pagination.current_page = 1; this.fetchData(); }},
  },
  created() {
    if(this.replacefilters) {
      this.filters = this.replacefilters;
    } else if(this.changefilters) {
      for(var i in this.changefilters) {
        this.filters[i] = this.changefilters[i];
      }
    }
    
    this.new_website = JSON.parse(JSON.stringify(this.default_new_website));

    this.setWhereIns('feed_types','filters','feed_type');

    this.fetchData();
  },
  mounted() {
    window.addEventListener('scroll', this.setStickyNav);
    window.addEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').addEventListener('scroll', this.setStickyNav); }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setStickyNav);
    window.removeEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').removeEventListener('scroll', this.setStickyNav); }
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.filters.page = this.pagination.current_page;
      this.$http.get('/api/websites/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        this.results = res.data.data;
        this.pagination = res.data;
        this.filters.total = res.data.total;
        this.loading = false;
        this.changes = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
    add_website() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.post('/api/websites/store', this.new_website).then(res => {
        // console.log(res);
        this.new_website = JSON.parse(JSON.stringify(this.default_new_website));
        this.$refs.modal_add_website.hide();
        this.fetchData();
        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
    setWhereIns(items,filters,wherein) {
      var temp = [], all = true; for(var i in this[items]) { if(this[items][i].active) { temp.push(this[items][i].id); } else { all = false; } }

      var path = filters.split('.');
      var obj = this;
      for(var i in path) { obj = obj[path[i]]; }
      if(all) { obj.whereins[wherein] = ""; } else { obj.whereins[wherein] = temp; }
    },
  }
}
</script>

<template>
  <div>
    
    <transition name="fade">
      <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
    </transition>
    <div class="px-4 pt-4 pb-3">
      <div class="row">
        <div class="col-lg-8">
          <div class="form-inline">
            <button type="button" @click="fetchData()" class="btn btn-light mr-2 mb-2"><Icon icon="ri:refresh-line"></Icon></button>
            <div class="form-group mr-2 mb-2">
              <input type="text" class="form-control" placeholder="Search..." v-model="filters.searchs.search1.value" @change="changes = true">
            </div>
            <div class="form-group mr-2 mb-2">
              <button type="button" class="btn btn-primary dropdown-toggle" @click="show_filters ? show_filters = false : show_filters = true">Filters
                <Icon v-if="show_filters" icon="ri:arrow-drop-down-line"></Icon>
                <Icon v-else icon="ri:arrow-drop-right-line"></Icon>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="text-lg-right mt-3 mt-lg-0">
            <button type="button" @click="new_website = JSON.parse(JSON.stringify(default_new_website)); $refs.modal_add_website.show()" class="btn btn-success ml-2"><Icon icon="ri:add-line"></Icon> Add New</button>
          </div>
          <b-modal ref="modal_add_website" centered size="xl" title="Create a new website" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
            <b-form @submit.prevent="add_website">
              <div class="p-4">
                <WebsitesForm :item="new_website"></WebsitesForm>
              </div>
              <footer class="modal-footer">
                <button type="button" class="btn btn-light" @click="$refs.modal_add_website.hide()" :disabled="dsbl_btn"><Icon icon="ri:close-fill" /> Cancel</button>
                <button type="submit" class="btn btn-primary" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
              </footer>
            </b-form>
          </b-modal>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div v-if="show_filters" class="form-inline px-2 pt-2 bg-gray-200">

        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="String List, Single" v-model="filters.wheres.status" :Options="status_list" placeholder="Filter by active..." @input="changes = true"></w-field>
        </div>

        <div class="form-group mr-2 mb-2 position-relative">
          <button type="button" class="btn btn-white dropdown-toggle font-weight-500" data-toggle="dropdown">
            Feed types: ({{feed_types.filter(b=>{return b.active}).length}}/{{feed_types.length}})
            <Icon icon="ri:arrow-down-s-line" />
          </button>
          <div class="dropdown-menu dropdown-menu-right" onclick="event.stopPropagation()">
            <div v-for="(item, index) in feed_types" :key="item.id" class="dropdown-item">
              <p-check class="p-default p-curve p-smooth pretty-light w-100" color="success-o" v-model="item.active" @change="setWhereIns('feed_types','filters','feed_type'); changes = true"> <span class="ml-1">{{item.name}}</span></p-check>
            </div>
          </div>
        </div>

        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="Date range" v-model="dateRange" placeholder="Filter by date created..." @input="changes = true"></w-field>
        </div>

        <div class="form-group mr-2 mb-2">
          <select class="form-control" v-model="filters.paginate">
            <option value="50">Per page: (50)</option>
            <option value="100">Per page: (100)</option>
            <option value="250">Per page: (250)</option>
            <option value="500">Per page: (500)</option>
            <option value="750">Per page: (750)</option>
            <option value="1000">Per page: (1000)</option>
          </select>
        </div>

      </div>
    </transition>
    <transition name="fade">
      <div v-if="changes" class="alert alert-info rounded-0 m-0">Click <Icon icon="ri:refresh-line" /> commit any changes made to filters.</div>
    </transition>
    <div class="row">
      <div class="col-sm-12">
        <div class="table-responsive m-0">
          <table class="table table-small sticky-header table-bordered-right table-hover mb-0 table-centered text-nowrap">
            <thead>
              <tr>
                <th class="font-weight-medium">Company logo</th>
                <th class="font-weight-medium"><tdsort coltext="Title" :orderby.sync="filters.orderbys.title" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Website ID" :orderby.sync="filters.orderbys.website_id" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Website domain" :orderby.sync="filters.orderbys.website_domain" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Listings feed" :orderby.sync="filters.orderbys.feed_type" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Active" :orderby.sync="filters.orderbys.status" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Last updated" :orderby.sync="filters.orderbys.updated_at" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Created on" :orderby.sync="filters.orderbys.created_at" @do="fetchData()"></tdsort></th>
              </tr>
              <tr class="sticky-thead bg-white">
                <th class="font-weight-medium">Company logo</th>
                <th class="font-weight-medium"><tdsort coltext="Title" :orderby.sync="filters.orderbys.title" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Website ID" :orderby.sync="filters.orderbys.website_id" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Website domain" :orderby.sync="filters.orderbys.website_domain" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Listings feed" :orderby.sync="filters.orderbys.feed_type" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Active" :orderby.sync="filters.orderbys.status" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Last updated" :orderby.sync="filters.orderbys.updated_at" @do="fetchData()"></tdsort></th>
                <th class="font-weight-medium"><tdsort coltext="Created on" :orderby.sync="filters.orderbys.created_at" @do="fetchData()"></tdsort></th>
              </tr>
            </thead>
            <tbody>
              <router-link v-for="(item, index) in results" :key="item.id" :to="'/websites/'+item.id" tag="tr" class="_c-pointer" exact>
                <td class="p-1" style="width:100px">
                  <router-link :to="'/websites/'+item.id">
                    

                    <img v-if="item.site_logo" :src="formatImage(item.site_logo)" style="width:100%;">
                    <img v-else src="@assets/images/no-image.jpg" style="width:100%;">
                  </router-link>
                </td>
                <td><router-link :to="'/websites/'+item.id" class="text-dark font-weight-bold">{{item.title}}</router-link></td>
                <td>{{ item.website_id }}</td>
                <td>{{ item.website_domain }}</td>
                <td>{{ item.feed_type }}</td>
                <td>
                  <div v-if="item.status" class="alert alert-success mb-0">Yes</div>
                  <div v-else class="alert alert-danger mb-0">No</div>
                </td>
                <td v-tippy :content="moment(item.updated_at).format('lll')">{{moment(item.updated_at).fromNow()}}</td>
                <td v-tippy :content="moment(item.created_at).format('lll')">{{moment(item.created_at).fromNow()}}</td>
              </router-link>
            </tbody>
          </table>
          <div class="p-3 border-top border-light">
            <w-pagination :pagination="pagination" @paginate="results=[]; fetchData()" :offset="4"></w-pagination>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

